<!--
Author: Lsc
Date: 2019-08-07
Desc: 针对预约页面列表组件
 -->
<template>
    <div class="comp-order-fund-list comp">
        <el-row v-if="fundInfo.length <= 0" class="no-funds">
            <el-col :span="12" :offset="8">
                <span class="no-funds-img" />
                <div class="no-funds-box">
                    <p>{{ noFundMsg }}</p>
                </div>
            </el-col>
        </el-row>
        <el-table
            v-if="fundInfo.length > 0"
            :data="fundAll"
            style="width: 100%"
            :show-header="false"
        >
            <el-table-column label="预约基金信息" width="1040">
                <template slot-scope="scope">
                    <el-row class="fund-list">
                        <el-col :span="24" class="fund-tit">
                            <span v-for="fund in recommendFund" :key="fund.tagids">
                                <span
                                    v-if="scope.row.tagids.indexOf(fund.tagid) > -1"
                                    class="type-index"
                                    :style="{ 'background-color': fund.tagcolor }"
                                >
                                    {{ fund.tagname }}
                                </span>
                            </span>
                            <span>
                                {{ scope.row.fundname + "(" + scope.row.fundcode + ")" }}
                                <i
                                    class="risk"
                                    aria-hidden="true"
                                    :class="$util.riskCla(scope.row.risklevel)"
                                >
                                    {{ $cache.getDict("110143", scope.row.risklevel) }}
                                </i>
                            </span>
                        </el-col>
                        <el-col v-if="scope.row.reason" :span="24" class="spe-intro">
                            <p>{{ scope.row.reason }}</p>
                        </el-col>
                        <el-col :span="5">
                            <span
                                class="big"
                                :class="
                                    scope.row.allud > 0
                                        ? 'add'
                                        : scope.row.allud < 0
                                        ? 'reduce'
                                        : ''
                                "
                            >
                                {{ $util.fmtNum(scope.row.allud) }}%
                            </span>
                            <p>成立以来</p>
                        </el-col>
                        <el-col :span="5">
                            <span
                                :class="
                                    scope.row.thisyear1ud > 0
                                        ? 'add'
                                        : scope.row.thisyear1ud < 0
                                        ? 'reduce'
                                        : ''
                                "
                            >
                                {{ $util.fmtNum(scope.row.thisyear1ud) }}%
                            </span>
                            <p>今年以来</p>
                        </el-col>
                        <el-col v-if="scope.row.fundtype !== '2'" :span="5">
                            <span>{{ $util.fmtNum(scope.row.nav, 4) }}</span>
                            <p>{{ "单位净值(" + $util.fmtDate(scope.row.navdate) + ")" }}</p>
                        </el-col>
                        <el-col v-else :span="5">
                            <span>{{ formatCurrencyAnnualRate(scope.row.growthrate) }}</span>
                            <p>七日年化</p>
                        </el-col>
                        <el-col v-if="scope.row.fundtype !== '2'" :span="5">
                            <span>{{ $util.fmtNum(scope.row.totalnav, 4) }}</span>
                            <p>累计净值(元)</p>
                        </el-col>
                        <el-col v-else :span="5">
                            <span>{{ $util.fmtNum(scope.row.fundincome, 4) }}</span>
                            <p>万份收益(元)</p>
                        </el-col>
                        <el-col :span="4">
                            <span>
                                {{
                                    $util.fmtNum(
                                        fundGrowQry
                                            ? scope.row[growData[fundGrowQry]]
                                            : scope.row.dayfloatprofit
                                    )
                                }}%
                            </span>
                            <p>{{ fundGrowQry ? growArea[fundGrowQry] : "日涨跌幅" }}</p>
                        </el-col>
                    </el-row>
                </template>
            </el-table-column>
            <el-table-column label="基金操作" prop="fundcode" align="center" min-width="98px">
                <template slot-scope="scope">
                    <el-tooltip
                        v-if="scope.row.isBeforeBuy"
                        class="item"
                        effect="info"
                        :content="scope.row.isBeforeBuy + ',不能购买'"
                        placement="left"
                    >
                        <el-button type="lock" size="small" class="alone-btn">预约购买</el-button>
                    </el-tooltip>
                    <el-button
                        v-else
                        type="orange"
                        size="small"
                        class="alone-btn"
                        v-on:click="callbackFn('7', scope.row.fundcode)"
                    >
                        预约{{ scope.row.isBeforeBuy == "" ? "购买" : "认购" }}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="allPage > conf.PAGE_SIZE" class="page-box">
            <el-pagination
                :page-size="Number(conf.PAGE_SIZE)"
                :current-page.sync="curPage"
                background
                layout="prev, pager, next"
                :total="Number(allPage)"
                v-on:current-change="dataReset"
            />
        </el-row>
    </div>
</template>
<script>
export default {
    name: "AssetsList",
    props: {
        fundInfo: {
            type: Array,
            default: () => {
                return [];
            },
            required: true
        },
        allPage: {
            type: String,
            default: ""
        },
        noFundMsg: {
            type: String,
            default: "基金公司没有添加基金产品，请联系基金公司添加！ "
        },
        fundGrowQry: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            conf: {}, // 初始化配置文件内容
            fundAll: [],
            curPage: 1,
            url: "", // 当前页面路由命名
            recommendFund: [],
            growArea: {
                4: "日涨跌幅",
                9: "近一周涨跌幅",
                5: "近一月涨跌幅",
                6: "近三月涨跌幅",
                7: "近六月涨跌幅",
                10: "近一年涨跌幅",
                11: "近两年涨跌幅",
                12: "近三年涨跌幅",
                13: "近五年涨跌幅"
            },
            growData: {
                4: "dayud",
                9: "week1ud",
                5: "month1ud",
                6: "month3ud",
                7: "month6ud",
                10: "year1ud",
                11: "year2ud",
                12: "year3ud",
                13: "year5ud"
            }
        };
    },
    watch: {
        fundInfo() {
            this.getNewFund();
        },
        allPage() {
            this.curPage = 1;
        }
    },
    created() {
        this.url = this.$route.name;
        this.conf = this.$util.getConfig().const;
        this.getFundLabel();
    },
    methods: {
        callbackFn(way, fundcode) {
            const fund = this.fundAll.filter((item) => {
                return item.fundcode === fundcode;
            });
            this.$emit("fund-continue", way, fund[0]);
        },
        getNewFund() {
            let _arr = [];
            this.fundInfo.forEach((fund, index) => {
                const _x = Object.assign({}, fund);
                _x.index = index + 1;
                _x.isBeforeBuy = this.$util.checkOrderBuy(_x);
                _arr.push(_x);
            });
            this.fundAll = _arr;
        },
        dataReset(val) {
            this.$emit("new-fund", val);
        },
        // 获取产品标签
        getFundLabel() {
            this.$util.request("trade/fund/tag").then((res) => {
                this.recommendFund = res.data;
                this.getNewFund();
            });
        },
        formatCurrencyAnnualRate(rate) {
            // 货币基金7日年化按产品口径固定展示3位小数，避免沿用万份收益/净值的4位精度。
            if (rate === "" || rate === null || rate === undefined) {
                return "--";
            }
            return this.$util.fmtNum(rate, 3) + "%";
        }
    }
};
</script>
<style lang="scss">
.comp-order-fund-list {
    .el-button--small {
        min-width: 80px;
        font-size: $f16;
        padding: 7px 15px;
    }
}
</style>
